// src/pages/LeadOverview.js
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getLeads } from '../services/leadsService';

const LeadOverview = () => {
    const { id } = useParams();
    const [lead, setLead] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLead = async () => {
            try {
                const response = await getLeads();
                const leads = response.data.leads;
                const foundLead = leads.find(l => String(l.id) === id);
                if (!foundLead) {
                    setError('Lead not found.');
                } else {
                    setLead(foundLead);
                }
            } catch (err) {
                setError('Error fetching lead data.');
            } finally {
                setLoading(false);
            }
        };

        fetchLead();
    }, [id]);

    if (loading) return <p>Loading lead data...</p>;
    if (error) return <p>{error}</p>;

    // Option 1: Merge the custom fields into the lead object so they display as separate keys.
    const mergedLead = { ...lead, ...(lead.customFields || {}) };
    // Remove the raw customFields property from the display.
    delete mergedLead.customFields;

    return (
        <div style={{ padding: '20px' }}>
            <h2>Lead Overview</h2>
            <Link to="/leads" style={{ marginBottom: '1rem', display: 'inline-block' }}>
                ← Back to Leads
            </Link>
            <div style={{ marginTop: '20px' }}>
                <h3>Lead Details</h3>
                <dl>
                    {Object.entries(mergedLead).map(([key, value]) => (
                        <React.Fragment key={key}>
                            <dt style={{ fontWeight: 'bold', marginTop: '10px' }}>{key}</dt>
                            <dd>{String(value)}</dd>
                        </React.Fragment>
                    ))}
                </dl>
            </div>
        </div>
    );
};

export default LeadOverview;
